<template>
  <div class="shouhufooter">
    <div class="left">
      <!-- <img src="@/assets/m-logo.png"> -->
      <p>
        联系我们: 2353434162@qq.com
        <br>
        QQ号:2353434162
      </p>
      <p>公司地址:湖南省长沙市开福区青竹湖街道青竹湖路118号金卓产业园第12栋109号2楼</p>
      <a href="https://beian.miit.gov.cn" target="_blank">
        <p>湘ICP备2022024524号-1</p>
      </a>
      <p>©长沙巨鸿信息科技有限公司</p>
    </div>
    <div class="right">
      <img class="img" src="@/assets/QR-Code.png" alt="">
      <a :href="url"> <img src="@/assets/m-download.png" /> </a>
    </div>
  </div>
</template>

<script>
import { url } from '@/data/index'
export default {
  data() {
    return {
      url: url
    }
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.shouhufooter {
  display: flex;
  justify-content: space-between;
  height: 220px;
  padding: 30px 13px 0px 18px;
  background-color: #323232;
  /* margin-bottom: 50px; */
}

.left {
  width: 360px;
  height: 100%;
  /* background-color: #fff;  */
}

.left img {
  width: 120px;
  height: 35px;
  background-color: #fff;
  border-radius: 5px;
}

.left p {
  margin-top: 8px;
  font-size: 12px;
  color: #fff;
}

.left a p {
  margin-top: 8px;
  font-size: 14px;
  color: #7779f0;
}

.right {
  text-align: right;
  /* background-color: blue; */
}

.right .img {
  margin-right: 12px;
  margin-bottom: 18px;
  width: 90px;
  height: 90px;
  visibility: hidden;
}

.right a {
  width: 110px;
  height: 30px;
}

.right a img {
  width: 110px;
  height: 30px;
}
</style>
